/**
 * 本地存储
 */
import Vue from 'vue'
import Storage from 'vue-divecore-storage'

Vue.use(Storage, {
  prefix: 'app_',
  storageTypes: ['session', 'local']
})

export const local = Vue.prototype.$localStorage
export const session = Vue.prototype.$sessionStorage
